
// export default QuizPreviewComponent;
import React, { useEffect, useState } from "react";
import { Card, Checkbox, Radio, Spin, Alert, Steps, Button } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import courseService from "../../services/course.service";
import MatchingQuestionViewer from "./MatchingQuestionViewer"; // adapte le chemin selon ton projet

const { Step } = Steps;

const QuizPreviewComponent = ({ quizId, attemptOnce = false }) => {

  console.log("🧪 attemptOnce prop value:", attemptOnce); // 🐞 trace ici
  const isAttemptOnce = attemptOnce === true || attemptOnce === 1;

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userAnswers, setUserAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const DragDropPreview = ({ question }) => {
    const [items, setItems] = useState(
      question.options.map((opt, index) => ({
        id: `option-${index}`,
        content: opt.text,
      }))
    );

    const onDragEnd = (result) => {
      if (!result.destination) return;
      const reordered = Array.from(items);
      const [moved] = reordered.splice(result.source.index, 1);
      reordered.splice(result.destination.index, 0, moved);
      setItems(reordered);
    };

    return (
      <div style={{ backgroundColor: "#f1f8e9", padding: "16px", borderRadius: "10px" }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-options">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ listStyleType: "none", paddingLeft: 0 }}
              >
                {items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          padding: "10px",
                          marginBottom: "8px",
                          backgroundColor: snapshot.isDragging ? "#c8e6c9" : "#e8f5e9",
                          border: "1px solid #c8e6c9",
                          borderRadius: "5px",
                          ...provided.draggableProps.style,
                        }}
                      >
                        {item.content}
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  };

  useEffect(() => {
    const loadQuiz = async () => {
      try {
        const questionList = await courseService.getQuestionsByQuiz(quizId);
        // const questionsWithOptions = await Promise.all(
        //   questionList.map(async (question) => {
        //     const options = await courseService.getAnswersByQuestion(question.id);
        //     const correctAnswers = options.filter((opt) => opt.isCorrect).map((opt) => opt.text);
        //     return { ...question, options, correctAnswers };
        //   })
        // );
        const questionsWithOptions = await Promise.all(
          questionList.map(async (question) => {
            if (question.questionType === "MATCHING") {
              const matchingPairs = await courseService.getMatchingPairsByQuestion(question.id);
              return { ...question, options: matchingPairs };
            } else {
              const options = await courseService.getAnswersByQuestion(question.id);
              const correctAnswers = options.filter((opt) => opt.isCorrect).map((opt) => opt.text);
              return { ...question, options, correctAnswers };
            }
          })
        );

        setQuestions(questionsWithOptions);
      } catch (err) {
        console.error("Erreur chargement quiz preview :", err);
        setError("Erreur lors du chargement du quiz.");
      } finally {
        setLoading(false);
      }
    };
    loadQuiz();
  }, [quizId]);

  const handleSubmit = () => {
    setSubmitted(true);
  };

  // const isCorrect = (question) => {
  //   const userAnswer = userAnswers[question.id];
  //   const correct = question.correctAnswers;
  //   if (Array.isArray(userAnswer)) {
  //     return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
  //   }
  //   return userAnswer === correct[0];
  // };

  const isCorrect = (question) => {
    const userAnswer = userAnswers[question.id];

    if (question.questionType === "MATCHING") {
      if (!userAnswer) return false;
      return question.options.every(
        (pair) => userAnswer[pair.leftText] === pair.rightText
      );
    }

    const correct = question.correctAnswers;

    if (Array.isArray(userAnswer)) {
      return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
    }

    return userAnswer === correct[0];
  };


  const calculateScore = () => {
    if (!submitted) return 0;
    return questions.reduce((sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum, 0);
  };

  const totalPossibleScore = questions.reduce((sum, q) => sum + (q.score || 0), 0);

  // const renderQuestion = (question) => {
  //   if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
  //     return (
  //       <Radio.Group
  //         value={userAnswers[question.id]}
  //         onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
  //         disabled={submitted}
  //         style={{ display: "flex", flexDirection: "column", gap: "10px" }}
  //       >
  //         {(question.options || []).map((option, i) => (
  //           <Radio key={i} value={option.text}>{option.text}</Radio>
  //         ))}
  //       </Radio.Group>
  //     );
  //   } else if (question.questionType === "QCM") {
  //     return (
  //       <Checkbox.Group
  //         value={userAnswers[question.id] || []}
  //         onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
  //         disabled={submitted}
  //         style={{ display: "flex", flexDirection: "column", gap: "10px" }}
  //       >
  //         {(question.options || []).map((option, i) => (
  //           <Checkbox key={i} value={option.text}>{option.text}</Checkbox>
  //         ))}
  //       </Checkbox.Group>
  //     );
  //   } else if (question.questionType === "DRAG_DROP") {
  //     return <DragDropPreview question={question} />;
  //   } else if (question.questionType === "MATCHING") {
  // return (
  //   <MatchingQuestionViewer
  //     pairs={question.options || []}
  //     questionId={question.id}
  //     userAnswers={userAnswers}
  //     setUserAnswers={setUserAnswers}
  //     disabled={submitted}
  //   />
  // );


  //   } else {
  //     return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
  //   }

  // };
  const renderQuestion = (question) => {
    if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
      return (
        <Radio.Group
          value={userAnswers[question.id]}
          onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
          disabled={submitted}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {(question.options || []).map((option, i) => (
            <Radio key={i} value={option.text}>{option.text}</Radio>
          ))}
        </Radio.Group>
      );
    } else if (question.questionType === "QCM") {
      return (
        <Checkbox.Group
          value={userAnswers[question.id] || []}
          onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
          disabled={submitted}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {(question.options || []).map((option, i) => (
            <Checkbox key={i} value={option.text}>{option.text}</Checkbox>
          ))}
        </Checkbox.Group>
      );
    } else if (question.questionType === "DRAG_DROP") {
      return <DragDropPreview question={question} />;
    } else if (question.questionType === "MATCHING") {
      return (
        // <MatchingQuestionViewer
        //   pairs={question.options || []}
        //   questionId={question.id}
        //   userAnswers={userAnswers}
        //   setUserAnswers={setUserAnswers}
        //   disabled={submitted}
        // />
        <MatchingQuestionViewer
          key={submitted + JSON.stringify(userAnswers[question.id] || {})} // 🔁 force update
          pairs={question.options || []}
          questionId={question.id}
          userAnswers={userAnswers}
          setUserAnswers={setUserAnswers}
          disabled={submitted}
        />

      );
    } else {
      return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
    }
  };

  if (loading) return <Spin tip="Chargement du quiz..." />;
  if (error) return <Alert message={error} type="error" />;
  if (!questions[currentStep]) return null;

  return (
    <div>
      <Steps
        current={currentStep}
        onChange={(step) => submitted && setCurrentStep(step)}
        style={{ marginBottom: 20 }}
      >
        {questions.map((q, index) => {
          let status = "wait";
          if (submitted) {
            status = isCorrect(q) ? "finish" : "error";
          }
          return (
            <Step
              key={q.id}
              title={
                <span style={{
                  fontWeight: currentStep === index ? "bold" : "normal",
                  color: currentStep === index ? "#1890ff" : undefined
                }}>
                  Q{index + 1}
                </span>
              }
              status={status}
            />
          );
        })}
      </Steps>

      {submitted && (
        <div style={{ textAlign: "right", marginBottom: 10 }}>
          <strong style={{ fontSize: 16 }}>
            🎯 Score : {calculateScore()} / {totalPossibleScore}
          </strong>
        </div>
      )}

      <Card
        title={`Question ${currentStep + 1}: ${questions[currentStep].text || "Sans titre"} (${questions[currentStep].score || 0} pts)`}
        style={{ marginBottom: "20px" }}
      >
        {renderQuestion(questions[currentStep])}

        {submitted && (
          <div style={{
            marginTop: "16px",
            padding: "12px",
            backgroundColor: isCorrect(questions[currentStep]) ? "#e8f5e9" : "#ffebee",
            borderRadius: "8px"
          }}>
            <strong style={{ color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828" }}>
              {isCorrect(questions[currentStep]) ? "✔ Bonne réponse" : "✘ Mauvaise réponse"}
            </strong>
            <div style={{ marginTop: "8px" }}>
              <strong>Explication :</strong>{" "}
              <span dangerouslySetInnerHTML={{
                __html: questions[currentStep].explanation || "<em>Pas d'explication disponible.</em>"
              }} />
            </div>
          </div>
        )}
      </Card>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button onClick={() => setCurrentStep((prev) => prev - 1)} disabled={currentStep === 0}>
          Précédent
        </Button>

        {currentStep < questions.length - 1 ? (
          <Button onClick={() => setCurrentStep((prev) => prev + 1)}>
            Suivant
          </Button>
        ) : (
          !submitted && (
            <Button type="primary" onClick={handleSubmit}>
              Soumettre
            </Button>
          )
        )}
      </div>

      {submitted && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            {/* <Button
              type="default"
              disabled={attemptOnce}
              onClick={() => {
                if (!attemptOnce) {
                  setSubmitted(false);
                  setUserAnswers({});
                  setCurrentStep(0);
                }
              }}
            >
              Recommencer
            </Button> */}

            <Button
              type="default"
              disabled={attemptOnce}
              onClick={() => {
                if (!attemptOnce) {
                  setSubmitted(false);
                  setUserAnswers({});
                  setCurrentStep(0);
                }
              }}
            >
              Recommencer
            </Button>


            {/* <span style={{ fontWeight: "bold", color: attemptOnce ? "red" : "green" }}>
              🔁 Attempt Once: {attemptOnce ? "1" : "0"}
            </span> */}
            <span style={{ fontWeight: "bold", color: attemptOnce ? "red" : "green" }}>
              🔒 Ce quiz est {attemptOnce ? "limité à une seule tentative" : "rejouable"}.
            </span>

          </div>

          {attemptOnce && (
            <p style={{ color: "red", marginTop: 10 }}>🔒 Ce quiz est à tentative unique.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizPreviewComponent;
